// extracted by mini-css-extract-plugin
export default {"root":"app_root__b30vp","open":"app_open__LhSDf","customTransition":"app_customTransition__EcRbW","close":"app_close__NV4UC"};